module.exports = __webpack_public_path__ + "img/img-gallery-2.b8d36c6e.jpg";